import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [AsyncPipe, RouterLink],
})
export class BreadcrumbComponent {
  breadcrumbService = inject(BreadcrumbService);
  breadcrumbs$ = this.breadcrumbService.getBreadcrumbs();
}
